import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   getClientReports,
   getAdminReports,
   getGoogleLogs,
   reportShare,
   downloadReport,
   editReportTemplate,
   getTemplate,
   getInventoryReport,
   getReportUsers
} from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "reports";

// Async thunk for fetching the Portal User list
export const clientReports = createAsyncThunk(
   `${namespace}/getClientReports`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await getClientReports({ payload });
         return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

// Async thunk for fetching the Portal User list
export const adminReports = createAsyncThunk(
   `${namespace}/getAdminReports`,
   async (
      { query = "", page = 1, limit = 10, sortby = "", order = "", user_id = "" },
      { rejectWithValue }
   ) => {
      try {
         const data = await getAdminReports(query, page, limit, sortby, order, user_id);
         return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

// Async thunk for fetching the Portal User list
export const googleLogs = createAsyncThunk(
   `${namespace}/googleLogs`,
   async ({ query = "", page = 1, limit = 10, sortby = "", order = "" }, { rejectWithValue }) => {
      try {
         const data = await getGoogleLogs(query, page, limit, sortby, order);
         console.log(data, "data");
         return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

export const emailShare = createAsyncThunk(
   `${namespace}/reportShare`,
   async ({ formData }, { rejectWithValue }) => {
      try {
         const data = await reportShare(formData);
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

export const reportDownload = createAsyncThunk(
   `${namespace}/reportDownload`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await downloadReport({ payload });

         const decryptedData = data.data;

         const blob = new Blob([decryptedData], { type: "application/pdf" });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement("a");
         link.href = url;
         link.setAttribute("download", "Inventory_Report.pdf");
         document.body.appendChild(link);
         link.click();
         link.remove();
         window.URL.revokeObjectURL(url);

         // const decryptedData = data.data;

         // // Handle the PDF download
         // const url = window.URL.createObjectURL(new Blob([decryptedData]));
         // const link = document.createElement("a");
         // link.href = url;
         // link.setAttribute("download", "report.pdf");
         // document.body.appendChild(link);
         // link.click();

         // // Clean up
         // link.remove();
         // window.URL.revokeObjectURL(url);

         return decryptedData;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

export const updateReportTemplate = createAsyncThunk(
   `${namespace}/updateReportTemplate`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await editReportTemplate({ payload });
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
)

export const downloadInventoryReport = createAsyncThunk(
   `${namespace}/downloadInventoryReport`,
   async ({ postData }, { rejectWithValue }) => {
      try {
         let payload = EncryptDecrypt.encryptdata(postData, secretKey);
         const data = await getInventoryReport({ payload });
         const decryptedData = data.data;
         console.log(new Uint8Array(decryptedData).slice(0, 10));

         const blob = new Blob([decryptedData], { type: "application/pdf" });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement("a");
         link.href = url;
         link.setAttribute("download", "Inventory_Summary_Report.PDF");
         document.body.appendChild(link);
         link.click();
         link.remove();
         window.URL.revokeObjectURL(url);
         return decryptedData;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

export const getPortalUsers = createAsyncThunk(
   `${namespace}/getPortalUsers`,
   async ({ jobId }, { rejectWithValue }) => {
      try {
         const data = await getReportUsers(jobId);
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

export const getReportTemplate = createAsyncThunk(
   `${namespace}/getReportTemplate`,
   async ({ }, { rejectWithValue }) => {
      try {
         const data = await getTemplate();
         return data;
      } catch (error) {
         return rejectWithValue(error.response);
      }
   }
);

const reports = createSlice({
   name: namespace,
   initialState: {
      clientReportsData: { count: 0, rows: [] },
      clientReportsLoading: false,
      clientReportsSuccess: false,
      clientReportsError: false,
      clientReportsErrorMessage: "",
      googleLogsData: { count: 0, rows: [] },
      googleLogsLoading: false,
      googleLogsSuccess: false,
      googleLogsError: false,
      googleLogsErrorMessage: "",
      emailShareLoading: false,
      emailShareSuccess: false,
      emailShareError: false,
      emailShareErrorMessage: false,
      gridReportDownloadLoading: false,
      gridReportDownloadSuccess: false,
      gridReportDownloadError: false,
      gridReportDownloadErrorMessage: false,
      updateData: [],
      updateReportSuccess: false,
      updateReportError: false,
      updateReportLoading: false,
      reportTemplateData: [],
      getReportTemplateSuccess: false,
      getReportTemplateError: false,
      getReportTemplateLoading: false,
      getReportTemplateErrorMessage: "",
      getPortalUsersData: [],
      getPortalUsersLoading: false,
      getInventoryReportLoading: false,
      getInventoryReportSuccess: false,
      getInventoryReportError: false
   },
   reducers: {
      resetSuccessFlag: (state, action) => {
         const { flag } = action.payload;
         state[flag] = false;
      },
      resetEmailShareState: (state, action) => {
         state.emailShareLoading = false;
         state.emailShareSuccess = false;
         state.emailShareError = false;
         state.emailShareErrorMessage = false;
      },
      reportSuccessFlag: (state, action) => {
         const { flag } = action.payload;
         state[flag] = false;
      },
   },
   extraReducers: builder => {
      builder
         // Handle get client reports
         .addCase(clientReports.pending, state => {
            state.clientReportsData = { count: 0, rows: [] };
            state.clientReportsLoading = true;
            state.clientReportsSuccess = false;
            state.clientReportsError = false;
            state.clientReportsErrorMessage = "";
         })
         .addCase(clientReports.fulfilled, (state, action) => {
            state.clientReportsData = action.payload.responses;
            state.clientReportsSuccess = true;
            state.clientReportsLoading = false;
         })
         .addCase(clientReports.rejected, (state, action) => {
            const payload = action.payload;
            state.clientReportsError = true;
            // state.clientReportsErrorMessage =
            //    payload && "errors" in payload ? payload.errors[0].message : payload.message;
            state.clientReportsLoading = false;
         })

         // Handle get admin reports
         .addCase(adminReports.pending, state => {
            state.clientReportsData = { count: 0, rows: [] };
            state.clientReportsLoading = true;
            state.clientReportsSuccess = false;
            state.clientReportsError = false;
            state.clientReportsErrorMessage = "";
         })
         .addCase(adminReports.fulfilled, (state, action) => {
            state.clientReportsData = action.payload.roomItems;
            console.log("adminReports", action.payload);

            state.clientReportsSuccess = true;
            state.clientReportsLoading = false;
         })
         .addCase(adminReports.rejected, (state, action) => {
            const payload = action.payload.data;
            state.clientReportsError = true;
            state.clientReportsErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
            state.clientReportsLoading = false;
         })

         // Handle get google reports
         .addCase(googleLogs.pending, state => {
            state.googleLogsData = { count: 0, rows: [] };
            state.googleLogsLoading = true;
            state.googleLogsSuccess = false;
            state.googleLogsError = false;
            state.googleLogsErrorMessage = "";
         })
         .addCase(googleLogs.fulfilled, (state, action) => {
            state.googleLogsData = action.payload;
            console.log("adminReports", action);

            state.googleLogsSuccess = true;
            state.googleLogsLoading = false;
         })
         .addCase(googleLogs.rejected, (state, action) => {
            const payload = action.payload;
            state.googleLogsError = true;
            // state.googleLogsErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            // state.googleLogsLoading = false;
         })

         .addCase(emailShare.pending, state => {
            state.emailShareLoading = true;
            state.emailShareSuccess = false;
            state.emailShareError = false;
            state.emailShareErrorMessage = false;
         })
         .addCase(emailShare.fulfilled, (state, action) => {
            console.log("reportShare", action);
            state.emailShareLoading = false;
            state.emailShareSuccess = true;
         })
         .addCase(emailShare.rejected, (state, action) => {
            console.log("reportShare", action);
            const payload = action.payload.data;
            state.emailShareLoading = false;
            state.emailShareError = false;
            state.emailShareErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
         })

         .addCase(reportDownload.pending, state => {
            state.gridReportDownloadLoading = true;
            state.gridReportDownloadSuccess = false;
            state.gridReportDownloadError = false;
            state.gridReportDownloadErrorMessage = false;
         })
         .addCase(reportDownload.fulfilled, (state, action) => {
            // console.log("reportDownload", action);
            state.gridReportDownloadLoading = false;
            state.gridReportDownloadSuccess = true;
         })
         .addCase(reportDownload.rejected, (state, action) => {
            // console.log("reportDownload", action);
            const payload = action.payload.data;
            state.gridReportDownloadLoading = false;
            state.gridReportDownloadError = false;
            state.gridReportDownloadErrorMessage =
               "errors" in payload ? payload.errors[0].message : payload.message;
         })
         .addCase(updateReportTemplate.pending, (state) => {
            state.updateReportLoading = true
            state.updateReportSuccess = false;
         })
         .addCase(updateReportTemplate.fulfilled, (state, action) => {
            state.updateData = action.payload;
            state.updateReportLoading = false
            state.updateReportSuccess = true;
            state.updateReportError = ''
         })
         .addCase(updateReportTemplate.rejected, (state, action) => {
            console.log(action, 'action');
            state.updateReportLoading = false;
            state.updateReportSuccess = false;
            if (action.payload.data.message) {
               state.updateReportError = action.payload.data.message;
            }
            else {
               state.updateReportError = action.error.message;
            }
         })
         .addCase(getReportTemplate.pending, (state) => {
            state.getReportTemplateLoading = true
            state.getReportTemplateSuccess = false;
         })
         .addCase(getReportTemplate.fulfilled, (state, action) => {
            console.log('action-for-report-template', action);
            const data = JSON.parse(EncryptDecrypt.decryptdata(action.payload.data.datas, secretKey));
            state.reportTemplateData = data?.reportTemplates || [];
            state.getReportTemplateLoading = false
            state.getReportTemplateSuccess = true;
            state.getReportTemplateError = ''
         })
         .addCase(getReportTemplate.rejected, (state, action) => {
            console.log(action, 'action-for-report-template');
            state.getReportTemplateLoading = false;
            state.getReportTemplateSuccess = false;
            if (action?.payload?.data.message) {
               state.getReportTemplateError = action.payload.data.message;
            }
            else {
               state.getReportTemplateError = action.error.message;
            }
         })
         .addCase(getPortalUsers.pending, (state) => {
            state.getPortalUsersLoading = true;
         })
         .addCase(getPortalUsers.fulfilled, (state, action) => {
            const data = JSON.parse(EncryptDecrypt.decryptdata(action.payload.data.datas, secretKey));
            state.getPortalUsersData = data.responses || [];
            state.getPortalUsersLoading = false;
         })
         .addCase(getPortalUsers.rejected, (state) => {
            state.getPortalUsersLoading = false;
         })
         .addCase(downloadInventoryReport.pending, (state) => {
            state.getInventoryReportLoading = true;
         })
         .addCase(downloadInventoryReport.fulfilled, (state, action) => {
            state.getInventoryReportLoading = false;
            state.getInventoryReportSuccess = true;
         })
         .addCase(downloadInventoryReport.rejected, (state, action) => {
            state.getInventoryReportLoading = false;
            state.getInventoryReportSuccess = false;
            if (action?.payload?.data.message) {
               state.getInventoryReportError = action.payload.data.message;
            }
            else {
               state.getInventoryReportError = action.error.message;
            }
         })
   },
});

export const { resetSuccessFlag, reportSuccessFlag, resetEmailShareState } = reports.actions;

export const reportsSelector = state => state[namespace];

export default reports.reducer;
